<div class="sidebar-content">
  <div class="nav-container d-flex flex-column justify-content-between">
    <ul class="navigation">
      <li *ngFor="let menuItem of menuItems"
        [ngClass]="{'active': menuItem.isActive, 'nav-item': true, 'menu-item': true}" [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{exact: true}">
        <div (click)="navigateToRoute(menuItem.path)">
          <a>
            <mat-icon *ngIf="menuItem.image.length == 0"
              [ngClass]="{'active-icon': menuItem.isActive}">{{menuItem.icon}}</mat-icon>
            <img *ngIf="menuItem.image.length > 0" [src]="menuItem.image" [ngClass]="{'active-icon': menuItem.isActive}"
              width="100%" />
            <span class="menu-title" [ngClass]="{'active-text': menuItem.isActive}">{{menuItem.title }}</span>
            <span *ngIf="menuItem.badge != '' " [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</div>